import { Link } from "react-router-dom";
import { Headset } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { cn } from "@/lib/utils";

const COPY = {
  dashboard: "AI-powered career support. Real recruiting professionals behind it.",
  companion: "You're not navigating your job search alone.",
  wellbeing: "You're not navigating your job search alone. A real recruiter is one booking away.",
  resume: "Get personalized guidance from people who understand how companies hire.",
  tracker: "Stuck on an application? Get a human perspective from a real recruiter.",
  interview: "Rehearse with AI, then meet with a real recruiter for a human perspective.",
  upgrade: "AI-powered career support. Real recruiting professionals behind it.",
};
const CTA = { free: "See recruiter support", pro: "Book your quarterly call", elite: "Book your monthly session" };
const SUB = {
  free: "Elite members get a 30-minute 1:1 recruiter session every month, included in the plan.",
  pro: "Your plan includes a 15-minute recruiter call each quarter. Elite adds a 30-minute 1:1 every month.",
  elite: "Your plan includes a 30-minute 1:1 recruiter session every month, with priority booking.",
};

export const HumanSupportBanner = ({ where = "dashboard", className }) => {
  const { tier } = useAuth();
  const t = SUB[tier] ? tier : "free";
  return (
    <Link to="/recruiter" className={cn("group mb-6 flex items-center gap-3 rounded-2xl border border-[#8224e3]/40 bg-gradient-to-r from-[#8224e3]/15 via-[#121214] to-[#121214] p-3 transition-[border-color] hover:border-[#8224e3]/80 sm:p-4", className)} data-testid={`human-support-${where}`}>
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#8224e3] text-white shadow-[0_0_20px_rgba(130,36,227,0.45)]"><Headset className="h-5 w-5" /></span>
      <span className="min-w-0 flex-1">
        <span className="block text-sm font-semibold text-zinc-100">{COPY[where] || COPY.dashboard}</span>
        <span className="block text-xs text-zinc-400">{SUB[t]}</span>
      </span>
      <span className="hidden shrink-0 rounded-full border border-[#8224e3]/60 px-3 py-1 text-xs font-semibold text-[#d7b6ff] transition-colors group-hover:bg-[#8224e3] group-hover:text-white sm:inline">{CTA[t]}</span>
    </Link>
  );
};
